package com.example.event_management_system.data.models

import kotlinx.serialization.Serializable

/**
 * In-memory representation of a single Email Workspace row.
 * The Firestore document `config/emailWorkspaces` stores a [WorkspacesDocument]
 * whose `workspaces` map is keyed by domain; each value is an [EmailWorkspaceData].
 *
 * The Cloud Function reads this document together with the actual service-account
 * JSON pulled from Google Secret Manager (looked up by `secretName`).
 */
data class EmailWorkspace(
    val domain: String,
    val enabled: Boolean = true,
    val fromName: String = "",
    val secretName: String = "",
    val secretVersion: String = "latest"
)

@Serializable
data class WorkspacesDocument(
    val workspaces: Map<String, EmailWorkspaceData> = emptyMap()
)

@Serializable
data class EmailWorkspaceData(
    val enabled: Boolean = true,
    val fromName: String = "",
    val secretName: String = "",
    val secretVersion: String = "latest"
)
